import axiosService from './axios-service';
import {UserDto} from '../dtos/user.dto';

class UserService {

    public loadUser = async (): Promise<UserDto> => {
        const res = await axiosService.get(`/api/user`);
        return res?.data;
    };

    public logout = async () => {
        await axiosService.post('/api/logout');
    };

}

const userService = new UserService();
export default userService;
